export default "__VITE_ASSET__Brljp02c__"